import React from "react";
import { useParams } from "react-router-dom";
import DocumentTable from "~/components/document-table/DocumentTable";
import EmptyDataView from "~/components/nodataview";
import { formatDate } from "~/utils/CSVFunctions";
import fileIcon from "../../../../assets/images/file-icon.png";
import emptyFileIcon from "../../../../assets/empty-file.svg";

const RequestAttachmentTable = ({
  attachment,
  loading,
  rows,
  onPageChange,
  isDataAvailable,
  first,
  handleAttachmentDelete,
  onSortOrderChange,
  isFilterApplied,
  totalRecords,
  onRefetch,
  useBackendFileName = false,
}) => {
  const { id } = useParams();

  if (!isDataAvailable) {
    return (
      <div className="attachment__table--container">
        <div className="flex flex-column justify-content-center align-items-center p-5 empty__dataview">
          <EmptyDataView
            Icon={
              <img
                className="users-card-icon-img"
                src={isFilterApplied ? emptyFileIcon : fileIcon}
                alt="File Icon"
              />
            }
            Header={
              isFilterApplied
                ? "It looks like there are no results based on the filters you applied"
                : "No files here yet"
            }
            Description={
              isFilterApplied
                ? "No matches were found. Please adjust your filters to improve your search."
                : "Start uploading files, or wait for others to do so."
            }
          />
        </div>
      </div>
    );
  }

  return (
    <div className="attachment__table--container">
      <DocumentTable
        value={attachment ?? []}
        loading={loading}
        formatDate={formatDate}
        onDelete={handleAttachmentDelete}
        relatedId={id}
        relatedType="REQUEST"
        useBackendFileName={useBackendFileName}
        totalRecords={totalRecords ?? 0}
        rows={rows ?? 10}
        first={first ?? 0}
        onPageChange={onPageChange}
        onSortOrderChange={onSortOrderChange}
        isFilterApplied={!!isFilterApplied}
        emptyMessage="No results were found"
        onRefetch={onRefetch}
      />
    </div>
  );
};

export default RequestAttachmentTable;
